import { Link, useParams } from "react-router-dom";
import './Project.scss';
import { projectDetails } from "../../helpers/constants";
import ExternalLink from "../../components/ExternalLink";
import Spacer from "../../components/Spacer";
import RenderIf from "../../components/RenderIf";
import { usePublisher } from "../../helpers/functions/hooks/events";
import { useEffect } from "react";
import { MotionValue } from "framer-motion";

const Project = (): JSX.Element => {
    const { project } = useParams();
    const projectInfo = projectDetails[project ?? ''];
    
    const publish = usePublisher();

    useEffect(() => {
        const value = new MotionValue();
        value.set(3);
        publish('scrollProgressRef', value);
    }, [publish]);

    if (projectInfo === undefined) {

    }

    return (
        <>
            <div className="projects-image-container" style={{ backgroundColor: projectInfo.backgroundColor }}>
                <Link className="hover-link" to={`/#${projectInfo.title.replace(/\s/g,'-')}`}>
                    Bac<span className="last-letter">k</span>
                </Link>
                <div className="projects-image" style={{ backgroundImage: `url(${projectInfo.largeImage}` }}></div>
            </div>
            <div className="projects-project-container">
                <h4>{projectInfo.projectType}</h4>
                <div className="projects-name-links">
                    <h1>{projectInfo.title}</h1>
                    <div className="projects-links">
                        <RenderIf condition={projectInfo.projectURL !== ''}>
                            <ExternalLink text="view project" href={projectInfo.projectURL} />
                        </RenderIf>
                        <RenderIf condition={projectInfo.githubURL !== ''}>
                            <ExternalLink text="view GitHub" href={projectInfo.githubURL} />
                        </RenderIf>
                    </div>
                </div>
                <p>{projectInfo.detailedDescription}</p>
                <div className="projects-images">
                    <RenderIf condition={projectInfo.images.at(0) !== undefined}>
                        <div className="projects-sm-image-container">
                            <div className="projects-sm-image">
                                <img src={projectInfo.images.at(0)} alt=""></img>
                            </div>
                            <Spacer />
                        </div>
                    </RenderIf>
                    <RenderIf condition={projectInfo.images.at(1) !== undefined}>
                        <div className="projects-sm-image-container">
                            <Spacer />
                            <div className="projects-sm-image">
                                <img src={projectInfo.images.at(1)} alt=""></img>
                            </div>
                        </div>
                    </RenderIf>
                </div>
                <p className="projects-skills">
                    {
                        projectInfo.skills.map((e, i) => 
                        (
                            <span key={i}>
                                <span className="projects-skill">{e}</span>
                                <RenderIf condition={i !== projectInfo.skills.length - 1}>
                                    <span className="projects-skill-divider">{'//'}</span>
                                </RenderIf>
                            </span>
                        ))
                    }
                </p>
            </div>
        </>
    )
}

export default Project;
